import { render, staticRenderFns } from "./DashboardNotificationsDoc.vue?vue&type=template&id=dd501f80"
import script from "./DashboardNotificationsDoc.vue?vue&type=script&lang=js"
export * from "./DashboardNotificationsDoc.vue?vue&type=script&lang=js"
import style0 from "./DashboardNotificationsDoc.vue?vue&type=style&index=0&id=dd501f80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports